import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bottom-nav_item-label" }

interface Props {
  name: string
  icon: string
  label: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BottomNavItem'
},
  __name: 'BottomNavItem',
  props: {
    name: {},
    icon: {},
    label: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: { name: __props.name },
    "active-class": "active",
    class: "bottom-nav_item"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VIcon, {
        icon: __props.icon,
        class: "bottom-nav_item-icon",
        size: "1.5rem"
      }, null, 8, ["icon"]),
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})